const sendContactUs = async (model) => {
    try {
        // Ensure the model parameter is valid
        if (!model || typeof model !== 'object') {
            throw new Error('Invalid model parameter. Expected an object.');
        }

        // Make the POST request to the PHP backend
        const response = await fetch('/postman/contact_us.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(model), // Convert the model to JSON for the backend
        });

        // Handle the response
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Parse the JSON response
        const result = await response.json();
        return result; // Return the received response
    } catch (error) {
        console.error('Error in sendEmail function:', error);
        throw error; // Re-throw the error to be handled by the caller
    }
};

// Export the function for use in other components
export default sendContactUs;